export default {
  async loadDataShared({ commit }, payload) {
    commit('setStaticColumns', payload.customColumns);
    commit('setJiraColumns', payload.jiraCustomColumns);

    if (!_.isEmpty(payload.multiview)) {
      commit('setProjectColumns', payload.multiview.multiviewCustomColumns);
      commit('setCustomColumns', payload.multiview.globalMultiviewCustomColumns);
    } else {
      commit('setProjectColumns', payload.userCustomColumnsData);
      commit('setCustomColumns', payload.globalCustomColumnsData);
    }
  },
};
